/**
 * 工具介绍相关API服务
 */

import { getAuthHeaders } from '../utils/auth';
import api from './index';

const API_URL = '/api/tool-introductions';

/**
 * 获取指定工具的介绍
 * @param {string} toolKey 工具标识
 * @returns {Promise<Object>} 工具介绍
 */
export async function fetchToolIntroduction(toolKey) {
  try {
    const response = await api.get(`${API_URL}/${toolKey}`);
    return response.data;
  } catch (error) {
    console.error('获取工具介绍失败:', error);
    throw error;
  }
}

/**
 * 管理员获取所有工具介绍
 * @returns {Promise<Array>} 工具介绍列表
 */
export async function fetchToolIntroductions() {
  try {
    const response = await api.get(API_URL);
    return response.data;
  } catch (error) {
    console.error('获取工具介绍列表失败:', error);
    throw error;
  }
}

/**
 * 上传工具介绍图片
 * @param {File} file 图片文件
 * @returns {Promise<Object>} 上传结果
 */
export const uploadToolIntroImage = async (file) => {
  try {
    const headers = getAuthHeaders();
    delete headers['Content-Type']; // 让浏览器自动设置multipart/form-data

    const formData = new FormData();
    formData.append('image', file);

    const response = await fetch(`${API_URL}/upload-image`, {
      method: 'POST',
      headers,
      body: formData
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('上传工具介绍图片失败:', error);
    throw error;
  }
};

/**
 * 上传工具介绍视频
 * @param {File} file 视频文件
 * @returns {Promise<Object>} 上传结果
 */
export const uploadToolIntroVideo = async (file) => {
  try {
    const headers = getAuthHeaders();
    delete headers['Content-Type']; // 让浏览器自动设置multipart/form-data

    const formData = new FormData();
    formData.append('video', file);

    const response = await fetch(`${API_URL}/upload-video`, {
      method: 'POST',
      headers,
      body: formData
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('上传工具介绍视频失败:', error);
    throw error;
  }
};

/**
 * 保存工具介绍（添加或更新）
 * @param {Object} data 工具介绍数据
 * @returns {Promise<Object>} 保存结果
 */
export const saveToolIntroduction = async (data) => {
  try {
    const headers = {
      ...getAuthHeaders(),
      'Content-Type': 'application/json'
    };
    
    const response = await fetch(API_URL, {
      method: 'POST',
      headers,
      body: JSON.stringify(data)
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('保存工具介绍失败:', error);
    throw error;
  }
};

/**
 * 删除工具介绍
 * @param {number} id 工具介绍ID
 * @returns {Promise<Object>} 删除结果
 */
export const deleteToolIntroduction = async (id) => {
  try {
    const headers = getAuthHeaders();
    
    const response = await fetch(`${API_URL}/${id}`, {
      method: 'DELETE',
      headers
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('删除工具介绍失败:', error);
    throw error;
  }
}; 